module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_vm._v("If nothing but the bright side of characters should be shown, we should sit down in despondency, and think it utterly impossible to imitate them in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("anything")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_vm._v("—S"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("AMUEL")]), _vm._v(" J"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OHNSON")]), _vm._v(", on the writing of biography")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0